import $ from 'jquery'

$(function () {
  // select all the buttons (marquee + anything with `data-cutlass-event`)
  const selectors = ['.split-marquee__cta', '[data-cutlass-event]']
  $(selectors.join(',')).not('.pe-site-header__item').on('click', function (e) {
    $(e.currentTarget).css('pointer-events', 'none')
  })
})
